import React, { useEffect, useState } from 'react';
import StatusEnum from 'axios/enum';
import { MethodEnum } from 'axios/type';
import useAxios from 'axios/useAxios';
import { APP_PATH } from 'config';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginAction } from 'reducer/common/login';
import { localStorageRetaierIdName } from 'consts';

interface IRequestParam {
  encryParamStr: string;
}
interface IReponseData {
  LineUserInfo: ILineUserInfo;
}
interface IformData {
  encryptedParameter: string;
}
interface ILineUserInfo {
  userId: string;
  retailerId: string;
  functionCode: string;
}

// Line 推播串接驗證頁面，參數加密驗證
const AuthLinePage = () => {
  const [errorMessage, setErrorMessage] = useState<string>('');
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setLoginRedux } = loginAction;
  const [formData, setFormData] = useState<IformData>({
    encryptedParameter: '',
  });
  const handleLogin = async () => {
    const response = await axios.doAxios<IRequestParam, IReponseData>(
      MethodEnum.post,
      '/token/lineLogin',
      {
        encryParamStr: formData.encryptedParameter,
      },
    );

    if (response && response.data) {
      if (response.data.status === StatusEnum.完成) {
        // 體系別預設選項;
        localStorage.setItem(
          localStorageRetaierIdName,
          response.data.data.LineUserInfo.retailerId,
        );
        dispatch(setLoginRedux(true));
        const url = `${APP_PATH}/${response.data.data.LineUserInfo.functionCode}`;
        navigate(url);
      }
    }
  };

  useEffect(() => {
    setErrorMessage('');
    // 使用 URLSearchParams 從查詢字符串中提取參數
    const params = new URLSearchParams(window.location.search);
    setFormData({
      encryptedParameter: params.toString(),
    });
  }, [window.location.search]);

  useEffect(() => {
    if (formData && formData.encryptedParameter) {
      console.log('formData=>', formData);
      handleLogin();
    }
  }, [formData]);

  return <>Line驗證頁</>;
};
export default AuthLinePage;
